import carbonlabellingApi from '../apis/carbonlabellings'

const state = {
  carbonLabellingUsers: {
    currentPage: 0,
    lastPage: 1,
    total: '',
    loading: false,
    data: [],
    joinTotal: '',
    limit: ''
  },
  myCarbonLabellingGroupInfos: [],
  myCarbonLabellingGroupInfosLoading: false,
  curGroupUser: {},
  memberChanges: {
    join: {
      data: [],
      loading: false,
      currentPage: 0,
      lastPage: 1,
      total: 0,
      perPage: 20,
      type: 'join'
    },
    leave: {
      data: [],
      loading: false,
      currentPage: 0,
      lastPage: 1,
      total: 0,
      perPage: 20,
      type: 'leave'
    },
    curType: 'join'
  },
  announcements: {
    data: [],
    loading: false,
    currentPage: 0,
    lastPage: 1,
    total: 0,
    perPage: 20
  }
}

const actions = {
  getCarbonLabellingGroupUsers ({ commit }, { groupId, page }) {
    commit('setCarbonLabellingUsersLoading', true)
    return carbonlabellingApi.getCarbonLabellingUsers(groupId, page)
      .then((res) => {
        commit('setCarbonLabellingUsers', res.data)
      })
  },
  addCarbonLabellingUser ({ commit }, { groupId, userId }) {
    return carbonlabellingApi.addCarbonLabellingUser(groupId, userId)
      .then((res) => {
        commit('addLabellingUser', res.data)
        return res.data
      })
  },
  removeCarbonLabellingUser ({ commit }, { groupId, groupUserId }) {
    return carbonlabellingApi.removeCarbonLabellingUser(groupId, groupUserId)
      .then((res) => {
        commit('removeLabellingUser', { groupUserId })
        return res.data
      })
  },
  bulkRemoveCarbonLabellingUsers ({ commit }, { groupId, groupUserIds }) {
    return carbonlabellingApi.bulkRemoveCarbonLabellingUsers(groupId, groupUserIds)
      .then((res) => {
        // 批量移除用户
        groupUserIds.forEach(groupUserId => {
          commit('removeLabellingUser', { groupUserId })
        })
        return res.data
      })
  },
  quitCarbonLabellingGroup ({ commit, dispatch }, { groupUserId, groupId }) {
    return carbonlabellingApi.quitCarbonLabellingGroup(groupUserId)
      .then((res) => {
        // 从我的团队列表中移除
        commit('removeMyCarbonLabellingGroup', { groupId })
        // 从当前团队用户列表中移除自己
        commit('removeLabellingUser', { groupUserId })
        // 从用户信息中移除团队
        dispatch('user/removeCarbonLabellingGroup', { groupId }, { root: true })
        return res.data
      })
  },
  getMyCarbonLabellingGroupInfos ({ commit }) {
    commit('setMyCarbonLabellingGroupInfosLoading', true)
    return carbonlabellingApi.getMyCarbonLabellingGroupInfos()
      .then((res) => {
        commit('setMyCarbonLabellingGroupInfos', res.data)
        commit('setMyCarbonLabellingGroupInfosLoading', false)
        return res.data
      })
      .catch((err) => {
        commit('setMyCarbonLabellingGroupInfosLoading', false)
        throw err
      })
  },
  getMemberChanges ({ commit, state }, { groupId, type = state.memberChanges.curType, page = 1, perPage = state.memberChanges[state.memberChanges.curType].perPage } = {}) {
    commit('setMemberChangesLoading', { type, loading: true })
    return carbonlabellingApi.getMemberChanges(groupId, { type, page, perPage })
      .then((res) => {
        commit('setMemberChanges', {
          data: res.data || {},
          type,
          perPage
        })
        return res && res.data
      })
      .catch((err) => {
        commit('setMemberChangesLoading', { type, loading: false })
        throw err
      })
  },
  loadMoreMemberChanges ({ commit, state, dispatch }, { groupId, type }) {
    const targetType = type || state.memberChanges.curType
    const currentData = state.memberChanges[targetType]

    if (currentData.loading || currentData.currentPage >= currentData.lastPage) {
      return Promise.resolve()
    }

    return dispatch('getMemberChanges', {
      groupId,
      type: targetType,
      page: currentData.currentPage + 1,
      perPage: currentData.perPage
    })
  },
  switchMemberChangesType ({ commit, state, dispatch }, { groupId, type }) {
    if (state.memberChanges.curType === type) {
      return Promise.resolve()
    }

    commit('setMemberChangesType', type)

    // 如果该类型还没有数据，则加载
    const targetData = state.memberChanges[type]
    if (targetData.data.length === 0 && !targetData.loading) {
      return dispatch('getMemberChanges', {
        groupId,
        type,
        page: 1,
        perPage: targetData.perPage
      })
    }
    return Promise.resolve()
  },
  updateCarbonLabellingGroupUser ({ commit, dispatch }, { groupUserId, data }) {
    return carbonlabellingApi.updateCarbonLabellingGroupUser(groupUserId, data)
      .then((res) => {
        // 若接口直接返回最新資料則就地更新，否則刷新一次
        if (res && res.data) {
          commit('setCurGroupUser', res.data)
          commit('updateLabellingUser', res.data)
          return res.data
        }
        return dispatch('getCarbonLabellingUserInfo', { groupUserId, refresh: true })
          .then((fresh) => {
            if (fresh) {
              commit('updateLabellingUser', fresh)
            }
            return fresh
          })
      })
  },
  getCarbonLabellingUserInfo ({ commit, state }, { groupUserId, refresh = false }) {
    if (refresh || !state.myCarbonLabellingGroupInfos.length) {
      return carbonlabellingApi.getCarbonLabellingUserInfo(groupUserId)
        .then((res) => {
          // 检查是否切换了用户，如果是则清空相关数据
          if (state.curGroupUser && state.curGroupUser.id && state.curGroupUser.id !== res.data.id) {
            commit('clearMemberChanges')
            commit('clearAnnouncements')
            commit('clearCarbonLabellingUsers')
          }
          commit('setCurGroupUser', res.data)
          return res.data
        })
    } else {
      const groupUser = state.myCarbonLabellingGroupInfos.find(item => item.id === groupUserId)
      if (groupUser) {
        // 检查是否切换了用户，如果是则清空相关数据
        if (state.curGroupUser && state.curGroupUser.id && state.curGroupUser.id !== groupUser.id) {
          commit('clearMemberChanges')
          commit('clearAnnouncements')
          commit('clearCarbonLabellingUsers')
        }
        commit('setCurGroupUser', groupUser)
      }
      return new Promise((resolve) => {
        resolve(groupUser)
      })
    }
  },
  getCarbonLabellingAnnouncements ({ commit, state }, { groupId, page = 1, perPage = state.announcements.perPage }) {
    commit('setAnnouncementsLoading', true)
    return carbonlabellingApi.getCarbonLabellingAnnouncements(groupId, page, perPage)
      .then((res) => {
        commit('setAnnouncements', {
          data: res.data || {},
          page,
          perPage
        })
        return res.data
      })
      .catch((err) => {
        commit('setAnnouncementsLoading', false)
        throw err
      })
  },
  publishCarbonLabellingAnnouncement ({ commit, dispatch }, { groupId, data }) {
    return carbonlabellingApi.publishCarbonLabellingAnnouncement(groupId, data)
      .then((res) => {
        // 发布成功后刷新公告列表
        dispatch('getCarbonLabellingAnnouncements', { groupId, page: 1 })
        return res.data
      })
  },
  loadMoreAnnouncements ({ commit, state, dispatch }, { groupId }) {
    if (state.announcements.loading || state.announcements.currentPage >= state.announcements.lastPage) {
      return Promise.resolve()
    }
    return dispatch('getCarbonLabellingAnnouncements', {
      groupId,
      page: state.announcements.currentPage + 1,
      perPage: state.announcements.perPage
    })
  }
}

const mutations = {
  setCarbonLabellingUsers (state, data) {
    state.carbonLabellingUsers = {
      data: data.current_page === 1 ? data.data : [...state.carbonLabellingUsers.data, ...data.data],
      loading: false,
      currentPage: data.current_page,
      lastPage: data.last_page,
      total: data.total,
      joinTotal: data.join_total,
      limit: data.limit
    }
  },
  setCarbonLabellingUsersLoading (state, loading) {
    state.carbonLabellingUsers = {
      ...state.carbonLabellingUsers,
      loading
    }
  },
  addLabellingUser (state, data) {
    if (state.carbonLabellingUsers.data.filter(item => item.id === data.id).length) {
      return
    }
    state.carbonLabellingUsers = {
      ...state.carbonLabellingUsers,
      data: [...state.carbonLabellingUsers.data, data],
      total: state.carbonLabellingUsers.total + 1
    }
  },
  removeLabellingUser (state, { groupUserId }) {
    state.carbonLabellingUsers = {
      ...state.carbonLabellingUsers,
      data: state.carbonLabellingUsers.data.filter(item => item.id !== groupUserId),
      total: state.carbonLabellingUsers.total - 1
    }
  },
  updateLabellingUser (state, groupUser) {
    // 更新列表中的该成员（若存在）
    const list = state.carbonLabellingUsers.data || []
    const idx = list.findIndex(item => item.id === groupUser.id)
    if (idx !== -1) {
      const newList = list.slice()
      newList[idx] = { ...list[idx], ...groupUser }
      state.carbonLabellingUsers = { ...state.carbonLabellingUsers, data: newList }
    }
    // 同步到“我的团队”列表（若存在）
    if (state.myCarbonLabellingGroupInfos && state.myCarbonLabellingGroupInfos.length) {
      const myIdx = state.myCarbonLabellingGroupInfos.findIndex(item => item.id === groupUser.id)
      if (myIdx !== -1) {
        const newMy = state.myCarbonLabellingGroupInfos.slice()
        newMy[myIdx] = { ...state.myCarbonLabellingGroupInfos[myIdx], ...groupUser }
        state.myCarbonLabellingGroupInfos = newMy
      }
    }
  },
  setMyCarbonLabellingGroupInfos (state, data) {
    state.myCarbonLabellingGroupInfos = data
  },
  setMyCarbonLabellingGroupInfosLoading (state, loading) {
    state.myCarbonLabellingGroupInfosLoading = loading
  },
  removeMyCarbonLabellingGroup (state, { groupId }) {
    state.myCarbonLabellingGroupInfos = state.myCarbonLabellingGroupInfos.filter(item => item.group.id !== groupId)
  },
  logout (state) {
    state.myCarbonLabellingGroupInfos = []
  },
  setCurGroupUser (state, data) {
    state.curGroupUser = data
  },
  setMemberChangesLoading (state, { type, loading }) {
    if (type && state.memberChanges[type]) {
      state.memberChanges[type].loading = loading
    } else {
      // 兼容旧的调用方式
      state.memberChanges.join.loading = loading
      state.memberChanges.leave.loading = loading
    }
  },
  setMemberChanges (state, { data, type, perPage }) {
    const currentPage = data.current_page || 1
    const targetType = type || state.memberChanges.curType

    if (state.memberChanges[targetType]) {
      state.memberChanges[targetType] = {
        ...state.memberChanges[targetType],
        data: currentPage === 1 ? (data.data || []) : [...state.memberChanges[targetType].data, ...(data.data || [])],
        loading: false,
        currentPage: data.current_page || currentPage,
        lastPage: data.last_page || currentPage,
        total: data.total || 0,
        perPage: data.per_page || perPage || state.memberChanges[targetType].perPage,
        type: targetType
      }
    }
  },
  setMemberChangesType (state, type) {
    if (type && state.memberChanges[type]) {
      state.memberChanges.curType = type
    }
  },
  setAnnouncements (state, { data, page, perPage }) {
    const currentPage = data.current_page || page || 1
    state.announcements = {
      data: currentPage === 1 ? (data.data || []) : [...state.announcements.data, ...(data.data || [])],
      loading: false,
      currentPage: data.current_page || currentPage,
      lastPage: data.last_page || currentPage,
      total: data.total || 0,
      perPage: data.per_page || perPage || state.announcements.perPage
    }
  },
  setAnnouncementsLoading (state, loading) {
    state.announcements = {
      ...state.announcements,
      loading
    }
  },
  clearMemberChanges (state) {
    state.memberChanges = {
      join: {
        data: [],
        loading: false,
        currentPage: 0,
        lastPage: 1,
        total: 0,
        perPage: 20,
        type: 'join'
      },
      leave: {
        data: [],
        loading: false,
        currentPage: 0,
        lastPage: 1,
        total: 0,
        perPage: 20,
        type: 'leave'
      },
      curType: 'join'
    }
  },
  clearAnnouncements (state) {
    state.announcements = {
      data: [],
      loading: false,
      currentPage: 0,
      lastPage: 1,
      total: 0,
      perPage: 20
    }
  },
  clearCarbonLabellingUsers (state) {
    state.carbonLabellingUsers = {
      currentPage: 0,
      lastPage: 1,
      total: '',
      loading: false,
      data: [],
      joinTotal: '',
      limit: ''
    }
  }
}

export default {
  state,
  actions,
  mutations
}
